var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-gender-wrapper" },
    [
      _c(
        "rb-smart-container",
        {
          attrs: {
            "slides-per-view-desktop": 4,
            "slides-per-view-tablet": 2,
            "columns-of-next-slide": 1,
            "column-gap": _vm.columnGap,
            "space-between-slides": _vm.spaceBetweenSlides,
            "stacked-on-mobile": true,
            "stacked-on-tablet": true,
          },
        },
        [_vm._t("banners")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }